import moment from 'moment-jalaali';
import { IRAN_NATIONAL_HOLIDAYS } from '../data/iranNationalHolidays';

/** تعطیلات رسمی ثابت (شمسی) — پشتیبان برای سال‌های بدون داده تفصیلی */
export const FIXED_SOLAR_HOLIDAYS = [
  { month: 1, day: 1, name: 'نوروز' },
  { month: 1, day: 2, name: 'نوروز' },
  { month: 1, day: 3, name: 'نوروز' },
  { month: 1, day: 4, name: 'نوروز' },
  { month: 1, day: 12, name: 'روز جمهوری اسلامی' },
  { month: 1, day: 13, name: 'روز طبیعت (سیزده‌به‌در)' },
  { month: 3, day: 14, name: 'رحلت امام خمینی (ره)' },
  { month: 3, day: 15, name: 'قیام ۱۵ خرداد' },
  { month: 11, day: 22, name: 'پیروزی انقلاب اسلامی' },
  { month: 12, day: 29, name: 'ملی شدن صنعت نفت' },
];

export const FRIDAY_LABEL = 'جمعه (تعطیل)';

const toLatinDigits = (value) => {
  if (value == null) return '';
  const persian = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const arabic = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  let result = String(value);
  for (let i = 0; i < 10; i += 1) {
    result = result.replace(new RegExp(persian[i], 'g'), String(i));
    result = result.replace(new RegExp(arabic[i], 'g'), String(i));
  }
  return result;
};

export const toJalaliHolidayKey = (year, month, day) => {
  const y = Number(toLatinDigits(year));
  const m = Number(toLatinDigits(month));
  const d = Number(toLatinDigits(day));
  if (!y || !m || !d) return null;
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
};

/** تبدیل تاریخ API (میلادی یا شمسی) به کلید شمسی YYYY-MM-DD */
export const holidayDateToJalaliKey = (dateStr) => {
  if (!dateStr) return null;
  const normalized = toLatinDigits(String(dateStr).trim());

  if (/^1[34]\d{2}[-/]\d{1,2}[-/]\d{1,2}/.test(normalized)) {
    const [y, m, d] = normalized.split(/[-/]/);
    return toJalaliHolidayKey(y, m, d);
  }

  const m = moment(normalized);
  if (!m.isValid()) return null;
  return m.format('jYYYY-jMM-jDD');
};

export const buildFixedSolarHolidayMap = (years = []) => {
  const map = new Map();
  const baseYear = moment().jYear();
  const yearList = years.length ? years : [baseYear - 1, baseYear, baseYear + 1];

  yearList.forEach((year) => {
    FIXED_SOLAR_HOLIDAYS.forEach(({ month, day, name }) => {
      const key = toJalaliHolidayKey(year, month, day);
      if (key) map.set(key, name);
    });
  });

  return map;
};

/** تعطیلات رسمی سال از تقویم ملی */
export const buildNationalHolidayMapForYear = (jalaliYear) => {
  const map = new Map();
  const year = Number(jalaliYear);
  const entries = IRAN_NATIONAL_HOLIDAYS[year];

  if (entries?.length) {
    entries.forEach(({ m, d, t }) => {
      const key = toJalaliHolidayKey(year, m, d);
      if (key) map.set(key, t);
    });
    return map;
  }

  FIXED_SOLAR_HOLIDAYS.forEach(({ month, day, name }) => {
    const key = toJalaliHolidayKey(year, month, day);
    if (key) map.set(key, name);
  });

  return map;
};

export const buildNationalHolidayMap = (years = []) => {
  const baseYear = moment().jYear();
  const yearList = years.length ? years : [baseYear - 1, baseYear, baseYear + 1];
  const map = new Map();

  yearList.forEach((year) => {
    buildNationalHolidayMapForYear(year).forEach((title, key) => {
      map.set(key, title);
    });
  });

  return map;
};

/** آیا روز جمعه است؟ (تقویم شمسی — weekDay.index === 6) */
export const isPersianFriday = (dateObject) => {
  if (!dateObject) return false;
  if (typeof dateObject.weekDay?.index === 'number') {
    return dateObject.weekDay.index === 6;
  }
  const key = dateObject.format?.('YYYY-MM-DD');
  if (!key) return false;
  const m = moment(key, 'jYYYY-jMM-jDD');
  return m.isValid() && m.day() === 5;
};
